import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

import { useFormatNumber } from '../../utils/format-number';

import { AnimationArrow } from './animation.arrow';

export type ItemOptions = {
  label: ReactNode;
  icon: ReactNode;
  value: number;
  valueIsConsumption?: boolean;
  hidden?: boolean;
};

type Props = {
  rotate: number;
} & ItemOptions;

export const AnimationItem = ({
  rotate,
  label,
  icon,
  value,
  valueIsConsumption,
}: Props) => {
  const formatNumber = useFormatNumber();

  const formattedValue = formatNumber(Math.abs(value), {
    style: 'unit',
    unit: 'kilowatt',
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
  });

  const inactive = Math.round(value * 10) / 10 === 0;

  let isConsumption = value < 0;
  if (valueIsConsumption) isConsumption = !isConsumption;

  let alignItems = 'flex-start';
  const justifyContent = 'center';
  if (rotate === 0 || rotate === 180) alignItems = 'center';
  if (rotate > 180) alignItems = 'flex-end';

  const translateCompensation = Math.abs(((rotate + 45) % 90) - 45) / 45;

  return (
    <Box
      sx={{
        position: 'absolute',
        transform: `rotate(${rotate}deg)`,
        height: { xs: 340, sm: 370 },
        width: 90,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            height: 90,
            width: 55,

            transform: `rotate(${-rotate}deg)`,
            marginTop: {
              xs: -translateCompensation,
              sm: -translateCompensation * 2.5,
            },

            display: 'flex',
            flexDirection: 'column',
            justifyContent,
            alignItems,
          }}
        >
          <Box
            sx={{
              '& .MuiSvgIcon-root': {
                fontSize: 40,
                color: 'primary.main',
              },
            }}
          >
            {icon}
          </Box>
          <Typography
            component="span"
            sx={{ fontWeight: 600, color: 'text.disabled' }}
          >
            {label}
          </Typography>
          <Typography component="span" sx={{ color: 'text.disabled' }}>
            {formattedValue}
          </Typography>
        </Box>

        <Box
          sx={{
            position: 'absolute',
            top: 90,
            left: 0,
            right: 0,
            textAlign: 'center',
          }}
        >
          {!inactive && (
            <AnimationArrow
              sx={{
                color: 'primary.main',
                transform: isConsumption ? 'rotate(90deg)' : 'rotate(-90deg)',
                transition: 'transform ease-in-out 200ms',
              }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};
